module.exports = __webpack_public_path__ + "img/at.e3fd5471.svg";